import { createAction } from 'redux-actions';
export const SAVE_SEAT_SERVICES = 'SAVE_SEAT_SERVICES';
export const saveSeatServices = createAction(SAVE_SEAT_SERVICES);
